import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "../Components/Sidebar/Sidebar";

export const ProtectedRoute = () => {
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  const authToken = localStorage.getItem("authToken");

  if (!isLoggedIn || !authToken) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Sidebar>
      <Outlet />
    </Sidebar>
  );
};
